export default "__VITE_ASSET__DGRZ_$QP__"